<template>
	<div  v-loading="loading" id="twicehandsIndex">
		<div>
			<router-view></router-view>
			<Header></Header>
			<TwiceTitle></TwiceTitle>
			<div class="container">
				<div class="class-box">
					<div class="class-list">
						<div class="name">影音分类：</div>
						<div v-for="(item,index) in video" v-bind:key="item.id"
							 @click="companyTypeEvent(index,item.id)" ref="companyTypeDOM"
							 :class="index == 0? 'first-selectd' : 'selectd'">{{item.name}}</div>
					</div>
					<!--二级分类-->
					<div style="padding-left:95px" class="class-list">
                <span v-for="(item,index) in childrenCategory" v-bind:key="item.id"
					  @click="childrenCategoryEvent(index,item.id)" ref="childrenCategoryDOM"
					  :class="index == 0? 'first-selectd' : 'selectd'">{{item.name}}</span>
					</div>
				</div>
				<div class="sort-box">
					<div class="sort-name">
						<div style="display:flex;cursor: pointer" v-for="(item,index) in sort" v-bind:key="item.id" ref="brandType"  @click="changeOrder(index)"
							 :class="index == 0 ? 'first-sort' : 'sort-all'">
							<div>{{item}}</div>
								 <img style="margin:auto;width:8px;height:8px" :src="index==0?imgBotY:imgBot" alt="">
							<div class="vertical"></div>
						</div>
						<div class="sort-all" style="display: flex; cursor: pointer; color: rgb(151, 151, 151);"><div :class="status == 1 ? 'first-sort' : 'sort-all'" @click="orderStatus(1)" style="margin-right: 26px">交易开启</div><div class="vertical"></div></div>
						<div class="sort-all" style="display: flex; cursor: pointer; color: rgb(151, 151, 151); margin-left: 0px"><div :class="status == 0 ? 'first-sort' : 'sort-all'" @click="orderStatus(0)" style="margin-right: 26px">交易关闭</div><div class="vertical"></div></div>
					</div>
					<div class="equipment">
						共{{total}}件器材
					</div>
				</div>

				<div class='none'  v-if="shop.length == 0">
				<img style="width:200px;height:250px" src="/static/image/null.svg" alt="">
				<div>非常抱歉！没有找到符合条件的商品!</div>
				<div style="font-size:14px;">您可以尝试：修改筛选条件或输入新的关键字重新查找</div>
				</div>

				<div   v-for="item in shop" v-bind:key="item.id" class="shop-details">
						<div>
							<router-link style="text-decoration:none;color:#444444;width:150px;height: 150px; line-height: 150px; background: #eff2f5; display: inline-block;text-align: center;" :to="{ path: '/twicehands/detail',query:{id: item.id} }" >
							<img style="max-width:150px;max-height:147px;vertical-align: middle; "  v-lazy="lazyImg(item.cover_img)" :onerror="defaultImg">
							</router-link>
						</div>
						<div class="right-details">
							<div   class="titledd">
								<router-link style="text-decoration:none;color:#444444;display: inline-block;align-items:center" :to="{ path: '/twicehands/detail',query:{id: item.id} }" >
								{{item.title}}<span class="ask-buy" >{{item.idle_type == 2?'求购':'出售'}}</span>	
								</router-link>
							</div>
							<div class="star">
								<div v-if="item.purity_name != '80新'">
									<img src="@/assets/wjx.png" alt="">
									<img src="@/assets/wjx.png" alt="">
									<img src="@/assets/wjx.png" alt="">
									<img src="@/assets/wjx.png" alt="">
									<img src="@/assets/wjxk.png" alt="">
								</div>
								<div v-else>
									<img src="@/assets/wjx.png" alt="">
									<img src="@/assets/wjx.png" alt="">
									<img src="@/assets/wjx.png" alt="">
									<img src="@/assets/wjxk.png" alt="">
									<img src="@/assets/wjxk.png" alt="">
								</div>
								<div class="condition">{{item.purity_name}}</div>
								<div class="address">所在地:{{item.province}}-{{item.city}}   </div>
								<div class="address">交易状态:{{item.status==1?'开启':'关闭'}}</div>
							</div>
							<div class="shop-describe">
								{{item.description}}
							</div>
							<div class="foot-box">
								<div class="money"><span style="font-size:14px">￥</span>{{item.sale_price}}</div>
								<div class="see-num">
									<a style="text-decoration:none" :href="'http://lt.hd199.com/user/'+ item.user_id"><div style="min-width:72px;" class="pic"><img style="width:24px;height:24px;" v-lazy="item.bbs.user_avatar" alt=""><span style="padding-left:10px;width:87px;font-size:12px;">{{item.bbs.username}}</span></div></a>
									<div style="min-width:60px;"  class="num"><img src="@/assets/liulan.png" alt=""> {{item.goods_hits}} 次</div>
									<div style="min-width:60px;"  class="num"><img src="@/assets/msg.png" alt=""> {{item.comment_count}} 条</div>
									<div class="num"><img src="@/assets/sj.png" alt="">发布于{{item.create_time|time}}</div>
								</div>
							</div>
						</div>
				</div>
			</div>
			<div v-if="shop.length != 0" class="pagination">
				<el-pagination
						background
						@current-change="changePage"
						:current-page="page"
						:page-size="20"
						layout="prev, pager, next"
						:total="total">
				</el-pagination>
				<span>共{{pagenum.last_page}}页</span>
			</div>
			</div>
			<Foot></Foot>
		</div>
	</div>
</template>

<script>
	import Foot from '@/components/common/Foot'
	import Header from '@/components/twicehands/Header'
	import TwiceTitle from '@/components/twicehands/TwiceTitle'
	import {tabSwitch} from '@/common/js/common'
	import Mixin from '@/common/js/mixin'
	export default {
		mixins: [Mixin],
		name: "twicehands-index",
		components:{
			Foot,
			Header,
			TwiceTitle
		},
		data (){
			return {
				brand:[],
				video:[],
				shop:[],
				total:0,
				current_page:0,
				page:1,
				pagenum:[],
				type:'',
				barandnum:'',
				order:'',
				status:1,
				sort:[
					'发布时间','价格','浏览量'
				],
				isA:false,  //判断点击,
				childrenCategorys:[],//子分类 总集合
				childrenCategory:[],
				category:'',//分类参数
				src:'',
				defaultImg: 'this.src="' + require('../../assets/Bitmap.png') + '"',
				brand_id:'',
				loading:true,//加载,
				imgTopY:'/static/image/top.png',
				imgBotY:'/static/image/bot.png',
				imgBot:'/static/image/xx.png'
			}
		},
		created () {
			if(this.getQueryString('code')){
				window.location.href="http://localhost:8081/login?code="+this.getQueryString('code')
			}
			this.getBrandList()
			this.getVideoList()
			this.getShopList()
		},
		computed: {
			keywords: function () {
				return this.$route.query.kw;
			}
		},
		methods:{
			getQueryString:function(name){
				var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
				var r = window.location.search.substr(1).match(reg);
				if(r!=null)
					return  decodeURI(r[2]);
				return null;
			},
			// 获取品牌分类
			getBrandList: function () {
				this.$get('/apis/idle/idleBrand').then((res)=>{
					if(res){
						this.brand = res.data;
						//头部推入全部选项
						this.brand.unshift({id:'',name:'全部',is_has_son:0});
					}
				})
			},
			// 获取音频分类
			getVideoList: function () {
				let _this=this;
				this.$get('/apis/idle/IdleCategory/parent/0').then((res)=>{
					if(res){
						this.video = res.data
						//头部推入全部选项
						this.video.unshift({id:'',is_has_son:0,name:'全部',parent_id:0,_children:[]});
						res.data.forEach(function(value,index){
							// 填充二级分类
							if(value._children.length !== 0){
								value._children.forEach(function(values,indexs){
									_this.childrenCategorys.push({id:values.id,name:values.name,pid:values.parent_id});
								})
							}
						});
					}

				})
			},
			// 影音分类
			companyTypeEvent(index,id) {
				let _this=this;
				tabSwitch(this,index,'companyTypeDOM');
				this.category = id
				//取子分类
				_this.childrenCategory=[];
				_this.childrenCategorys.forEach(function(value,index){
					if(id==value.pid){
						_this.childrenCategory.push({id:value.id,name:value.name,pid:value.parent_id});
					}
				})
				if(index!=0){
					//头部推入全部选项
					this.childrenCategory.unshift({id:id,is_has_son:0,name:'全部',parent_id:0,_children:[]});
				}
				this.category = id
				//二级分类变色
				this.childrenCategoryEvent(0,id)
			},
			childrenCategoryEvent(index,id){
				tabSwitch(this,index,'childrenCategoryDOM');
				this.category = id
				this.getShopList()
			},
			// 品牌分类
			companyType(index,id) {
				tabSwitch(this,index,'companyType');
				this.brand_id = id
				this.getShopList()

			},
			changeOrder(index) {
				this.$refs.brandType.forEach((ele, Mindex) => {
					index === Mindex ? (this.$refs.brandType[Mindex].style.color = '#F9BE04')
						: (this.$refs.brandType[Mindex].style.color = '#979797')
				})
				this.isA = !this.isA
				let imgTopY='/static/image/top.png';
				let imgBotY='/static/image/bot.png';
				let imgBot='/static/image/xx.png'
				if (index == 0 && this.isA == false){
					console.log(1)
					this.$refs.brandType[index].childNodes[2].src=imgBotY;
					this.order = 'create_time desc';
				}
				if (index == 0 && this.isA == true){
					this.$refs.brandType[index].childNodes[2].src=imgTopY;
					this.order = 'create_time asc';
				}
				if (index == 1 && this.isA == true){
					this.$refs.brandType[index].childNodes[2].src=imgBotY;
					this.order = 'sale_price desc';
				}
				if (index == 1 && this.isA == false){
					this.$refs.brandType[index].childNodes[2].src=imgTopY;
					this.order = 'sale_price asc';

				}
				if (index == 2 && this.isA == true){
					this.$refs.brandType[index].childNodes[2].src=imgBotY;
					this.order = 'goods_hits desc';
				}
				if (index == 2 && this.isA == false){
					this.$refs.brandType[index].childNodes[2].src=imgTopY;
					this.order = 'goods_hits asc';

				}
				this.$refs.brandType.forEach(function(value,indexs){
					if(indexs!=index){
						value.childNodes[2].src=imgBot;
					}
				})
				//当前页码置1
				if(this.page!=1){
					document.querySelector('.pagination li:first-child').click()
				}else{
					this.getShopList();
				}
			},
			getShopList: function () {
				this.$get('/apis/idle/idle', {
					params: {
						brand:this.brand_id,
						type:this.type,
						key: this.keywords,
						category:this.category,
						purity:'',
						page:this.page,
						order:this.order,
						status:this.status
					}
				}).then((res)=>{
					if(res){
						this.shop = res.data.data
						// 分页参数
						this.pagenum=res.data
						this.total = res.data.total
						this.page = res.data.current_page
						this.loading = false;
					}
				})
			},

			changePage(currentPage){
				this.page = currentPage;
				this.getShopList();
				document.body.scrollTop = document.documentElement.scrollTop = 0
			},
			orderStatus(val){
				this.status=val
				this.getShopList();
			}
		},
		watch:{
			keywords:function(){
				this.page = 1
				this.getShopList();
			}
		}
	}
</script>
<style >
	body{
		margin: 0px;
	}
	#twicehandsIndex{
		min-width: 1200px;
	}
	.el-submenu .el-menu{
		z-index: 1;
	}
	.none{
		text-align: center;
		color: #555;
		font-size: 18px;
		min-height: 200px;
		margin: auto;
		min-height: 400px;
	}
	#twicehandsIndex .container{
		box-sizing: border-box;
		 width: 1200px;
		 margin: auto;
	}
	#twicehandsIndex .class-box{
		background:  #fbfbfb;
		padding-bottom: 25px;
		margin-top: 10px;
	}
	#twicehandsIndex .class-list{
		display: flex;
	}
	#twicehandsIndex .name{
		margin-top: 25px;
		margin-left: 13px;
	}
	.el-pagination.is-background .el-pager li.number:hover{
		color:#f9be04;
	}

	.el-pagination.is-background .el-pager li.active:hover{
		color:#fff;
	}
	#twicehandsIndex .selectd{
		border: 1px solid #D3D3D2;
		border-radius: 8px;
		margin-top: 25px;
		padding: 0 12px;
		font-size: 12px;
		color: #D3D3D2;
		margin-left: 20px;
		cursor: pointer;
		height: 20px;
		line-height: 20px;
	}
	#twicehandsIndex .first-selectd{
		border: 1px solid #F9BE04;
		border-radius: 8px;
		color: #F9BE04;
		margin-top: 25px;
		padding: 0 12px;
		font-size: 12px;
		cursor: pointer;
		height: 20px;
		line-height: 20px;

	}
	#twicehandsIndex  .search-money{
		margin-top: 25px;
		margin-left: 20px;
	}
	#twicehandsIndex .search-money input{
		border: 1px solid #d3d3d2;
		background: #EDEDED;
		width: 75px;
		height: 21px;
		font-size: 12px;
		text-align: center;
		border-radius: 2px;
	}
	#twicehandsIndex .search-money span{
		color: #d3d3d2
	}
	.el-submenu .el-menu{
		z-index: 1;
	}
	#twicehandsIndex .sort-box{
		display: flex;
		justify-content: space-between;
		border: 1px solid #f7f7f7;
		height: 42px;
		line-height: 42px;
		margin-top: 25px;
		margin-bottom:25px;
	}
	#twicehandsIndex .sort-name{
		display: flex;
	}
	#twicehandsIndex .sort-all{
		width: 135px;
		font-size: 12px;
		color: #979797;
		margin-left: 43px;
	}
	#twicehandsIndex .sort-all img{
		width: 6px;
		height: 6px;
		padding-left: 5px;
	}
	#twicehandsIndex .equipment{
		font-size: 12px;
		color: #979797;
		margin-right: 22px;
	}
	#twicehandsIndex .first-sort{
		color: #F9BE04;
		width: 135px;
		font-size: 12px;
		margin-left: 43px;
	}
	#twicehandsIndex .vertical{
		background: #CECECE;
		width: 1px;
		height: 26px;
		margin-top: 8px;
	}
	#twicehandsIndex .shop-details{
		display: flex;
		border:1px solid #f7f7f7;
		box-sizing: border-box;
		padding: 10px;
		margin-top: -1px;
	}
	#twicehandsIndex .right-details{
		margin-left: 20px;
		width: 100%;
	}
	#twicehandsIndex .right-details .titledd{
		font-size: 20px;
		color: #444444;
	}
	#twicehandsIndex .star{
		display: flex;
		line-height: 17px;
		margin-top: 12px;
	}
	#twicehandsIndex .star img{
		width: 13px;
		height: 13px;
	}
	#twicehandsIndex .condition{
		font-size: 12px;
		color: #F9BE04;
		margin-left: 10px;
	}
	#twicehandsIndex .address{
		font-size: 12px;
		color: #737373;
		margin-left: 15px;
	}
	#twicehandsIndex .shop-describe{
		font-size: 12px;
		color: #2E2E2E;
		margin-top: 11px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;

	}
	#twicehandsIndex .money{
		font-size: 30px;
		color: #F9BE04;
	}
	#twicehandsIndex .foot-box{
		display: flex;
		justify-content: space-between;
		margin-top: 15px;
	}
	#twicehandsIndex .see-num{
		display: flex;
	}
	#twicehandsIndex .pic{
		display: flex;
		align-items: center;
		font-size: 18px;
		color: #656565;
		line-height: 39px;
	}
	#twicehandsIndex .pic img{
		width: 32px;
		height: 32px;
		border-radius: 16px;
	}
	#twicehandsIndex .num{
		font-size: 12px;
		color: #656565;
		display: flex;
		align-items: center;
		margin-left:15px;
		line-height: 39px;
	}
	#twicehandsIndex .num img{
		padding-right: 5px;
	}
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background: rgba(0,0,0,0.00);
		border: 1px solid #F9BE04;
	}
	.el-pagination.is-background .el-pager li{
		border: 1px solid #D5D5D5;
		color: #D5D5D5;
	}
	#twicehandsIndex .pagination{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	#twicehandsIndex .pagination input{
		width: 28px;
		border: 1px solid #D5D5D5;
		height: 26px;
		margin-left: 4px;
		margin-right: 4px;
	}
	#twicehandsIndex .pagination span{
		font-size: 14px;
		color: #D5D5D5;
		letter-spacing: 0;
		line-height: 18px;
		margin-left: 11px;
	}
	#twicehandsIndex .pagination-button{
		color: #fff;
		background: #F9BE04;
		box-shadow: 0 2px 4px 0 rgba(200,200,200,0.50);
		border-radius: 2px 2px 2px 0 2px;
		border: none;
		height: 30px;
		width: 65px;
		margin-left: 8px;
	}
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background: #F9BE04;
	}
	.el-radio__input.is-checked+.el-radio__label{
		color:#F9BE04
	}
	.el-radio__input.is-checked .el-radio__inner{
		background: #F9BE04;
		border-color:#F9BE04
	}
	.el-upload--picture-card{
		margin-left: 5px;
	}
	.el-input{
		margin-left: 5px;
	}
	.ask-buy{
		background: #F9BE04;
		color: #fff;
		font-size: 12px;
		margin-left: 10px;
		padding-left: 3px;
		padding-right: 3px;
	}
</style>


// WEBPACK FOOTER //
// src/components/twicehands/Index.vue